module.exports = __webpack_public_path__ + "img/liulianbingjing.25de07dd.jpg";